import type { FC } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useTranslation } from "@/shared/hooks";

interface AssistantSignInProps {
  onSignIn: () => void;
}

/** Помощник доступен только вошедшему зрителю: вместо ленты зовём войти. */
export const AssistantSignIn: FC<AssistantSignInProps> = ({ onSignIn }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        px: 4,
        textAlign: "center",
      }}
    >
      <LockOutlinedIcon color="disabled" sx={{ fontSize: 40 }} />
      <Typography variant="body1">{t("assistant.signInTitle")}</Typography>
      <Button variant="contained" disableElevation onClick={onSignIn}>
        {t("assistant.signIn")}
      </Button>
    </Box>
  );
};
